import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import interRegular from '../../../Assets/fonts/Inter/static/Inter-Regular.ttf';
import interBold from '../../../Assets/fonts/Inter/static/Inter-Bold.ttf';

let interReady;

const robotoVfs = () =>
  (pdfFonts && pdfFonts['Roboto-Regular.ttf'] && pdfFonts) ||
  pdfFonts?.default ||
  pdfFonts?.pdfMake?.vfs ||
  pdfFonts?.vfs ||
  {};

const ttfToBase64 = async (url) => {
  const blob = await (await fetch(url)).blob();
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  return String(dataUrl).split(',')[1];
};

/** Register Inter once for pdfMake 0.2 (uses addVirtualFileSystem, not pdfMake.vfs). */
export const ensureInterPdfFont = () => {
  if (interReady) return interReady;
  interReady = (async () => {
    const [regular, bold] = await Promise.all([
      ttfToBase64(interRegular),
      ttfToBase64(interBold),
    ]);
    pdfMake.addVirtualFileSystem({
      ...robotoVfs(),
      'Inter-Regular.ttf': regular,
      'Inter-Bold.ttf': bold,
    });
    pdfMake.addFonts({
      Inter: {
        normal: 'Inter-Regular.ttf',
        bold: 'Inter-Bold.ttf',
        italics: 'Inter-Regular.ttf',
        bolditalics: 'Inter-Bold.ttf',
      },
    });
  })();
  return interReady;
};
